import React from "react";
import { ArcElement, Chart } from "chart.js";
import { Doughnut as DoughnutCjs } from "react-chartjs-2";
Chart.register(ArcElement);
var Doughnut = function (_a) {
    var options = _a.options, data = _a.data;
    return React.createElement(DoughnutCjs, { options: options, data: data });
};
export default Doughnut;
//# sourceMappingURL=Doughnut.js.map